// @ts-nocheck
import { MARK_NOTE_RESOLVED_EVENT, NEW_CHAT_MESSAGE, UPDATE_CHAT_MSG_STATUS } from "../../customHooks/socketEvents/noteOneOnOneMessaging/constants";
import { emitSocketEvent } from "../../services/apiService"
import {ON_NEW_NOTE_ONE_ON_ONE_CHAT, MARK_NOTE_RESOLVED, MARK_NOTE_UNRESOLVED } from "../constants/noteoneononemessaging";

export const sendOneOnOneNoteActions = ({
    payload,
    chatId,
    params,
    
    successCallback,
    failureCallback
  }) => {
    return async (dispatch, getState) => {

      try {
        const response = await emitSocketEvent({
          event: NEW_CHAT_MESSAGE,
          payload: {
            ...payload,
            senderToken: getState()?.auth?.userToken,
            roomId: chatId
          }
        });

        if (response?.status === "ok") {
          const sentMessage = response?.data?.data;
          dispatch({
            type: ON_NEW_NOTE_ONE_ON_ONE_CHAT,
            payload: {
              roomId: chatId,
              message: sentMessage,
            },
          });

          if (successCallback) {
            successCallback({ res: response?.data });
          }
        } else {
          if (failureCallback) {
            failureCallback({ error: response?.error });
          }
        }
      } catch (err) {}
    };
}

export const markNoteResolvedActions = ({
  chatId,
  noteIds,
  isResolved,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {

    try {
      const response = await emitSocketEvent({
        event: MARK_NOTE_RESOLVED_EVENT,
        payload: {
          noteIds,
          token: getState()?.auth?.userToken,
          roomId: chatId
        }
      });

      if (response?.status === "ok") {
        dispatch({
          type: isResolved  ? MARK_NOTE_RESOLVED: MARK_NOTE_UNRESOLVED,
          payload: {
            roomId: chatId,
            messageIds: response?.data?.map(item => item?._id),
          },
        });

        if (successCallback) {
          successCallback({ res: response?.data });
        }
      } else {
        if (failureCallback) {
          failureCallback({ error: response?.error });
        }
      }
    } catch (err) {}
  };
}
export const markNotesAsReadActions = ({
  chatId,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {

    try {
      const response = await emitSocketEvent({
        event: UPDATE_CHAT_MSG_STATUS,
        payload: {
          token: getState()?.auth?.userToken,
          roomId: chatId
        }
      });

      if (response?.status === "ok") {
        if (successCallback) {
          successCallback({ res: response?.data });
        }
      } else {
        if (failureCallback) {
          failureCallback({ error: response?.error });
        }
      }
    } catch (err) {}
  };
}